import React, { useEffect } from 'react';
import { DraggableComponentProps } from 'features/document/constants';
import { Box, Typography } from '@mui/material';
import { isBillToElement } from 'utils/typeGuards';
import { parseJustifyContentToAlignment } from 'utils/alignmentParsers';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { selectQuote } from 'features/salesforce/salesforceSlice';
import { updateElementById } from 'features/document/documentSlice';

export default function BillTo({ currentElement }: DraggableComponentProps) {
  if (!isBillToElement(currentElement)) {
    return null;
  }

  const dispatch = useAppDispatch();
  const quote = useAppSelector(selectQuote);

  const { billTo, address, country, city } = currentElement.content;
  const { justifyContent } = currentElement.style;
  const alignment = parseJustifyContentToAlignment(justifyContent);

  useEffect(() => {
    const { BillingName, BillingCountry, BillingCity, BillingPostalCode, BillingState, BillingStreet } = quote;
    const newBillTo = {
      billTo: BillingName,
      address: `${BillingStreet} ${BillingPostalCode}`,
      city: `${BillingCity} ${BillingState}`,
      country: BillingCountry,
    };
    dispatch(
      updateElementById({
        elementId: currentElement.id,
        content: newBillTo,
        style: {},
      })
    );
  }, [dispatch, quote]);

  return (
    <Box
      alignItems={justifyContent}
      display={'flex'}
      justifyContent={'center'}
      flexDirection={'column'}
      padding={'8px'}
      width={'100%'}
    >
      <Typography
        sx={{
          textAlign: alignment,
        }}
        fontSize={'16px'}
        fontWeight={'500'}
      >
        Bill To
      </Typography>
      <Typography
        sx={{
          textAlign: alignment,
        }}
        fontSize={'16px'}
        flexWrap={'wrap'}
      >
        {billTo || 'Name'}
      </Typography>
      <Typography
        sx={{
          textAlign: alignment,
        }}
        fontSize={'16px'}
        flexWrap={'wrap'}
      >
        {address.includes('null') ? 'Address ZIP/Postal Code, City, State' : `${address}, ${city}`}
      </Typography>
      <Typography
        sx={{
          textAlign: alignment,
        }}
        fontSize={'16px'}
        flexWrap={'wrap'}
      >
        {country || 'Country'}
      </Typography>
    </Box>
  );
}
